document.addEventListener("DOMContentLoaded", () => {
  if (window.variantStrings && !window.variantStrings._addToCartDefault) {
    window.variantStrings._addToCartDefault = window.variantStrings.addToCart
  }

  const currentDate = () => {
    const idInput = document.querySelector(".product-variant-id")
    return idInput ? window.preorderVariants?.[idInput.value] : null
  }

  const applyPreorder = () => {
    const date = currentDate()

    if (window.variantStrings) {
      window.variantStrings.addToCart = date
        ? "Pre-order"
        : window.variantStrings._addToCartDefault
    }

    const input = document.querySelector("[data-preorder-input]")
    if (input) {
      input.disabled = !date
      input.value = date ? `Ships from ${date}` : ""
    }

    // Preorder alert: show/hide + update date text
    const alertWrap = document.querySelector("[data-preorder-alert]")
    if (alertWrap) {
      alertWrap.hidden = !date
      if (date) {
        const textEl = [...alertWrap.querySelectorAll("*")].find(
          n => n.children.length === 0 && n.textContent.includes("pre-order")
        )
        if (textEl) textEl.textContent = `This item is on pre-order and will ship from ${date}.`
      }
    }

    // Hide inventory status while on pre-order
    const inventoryEl = document.querySelector(".product__inventory")
    if (inventoryEl) {
      inventoryEl.hidden = !!date
    }

    if (date) {
      document.querySelectorAll(".product-form__submit").forEach(btn => {
        const span = btn.querySelector("span")
        if (!span || btn.disabled) return

        const separator = span.querySelector(".selleasy-btn-separator")
        if (separator) {
          const baseNode = span.firstChild
          if (baseNode && baseNode.textContent.trim() !== "Pre-order") {
            baseNode.textContent = "Pre-order "
          }
        } else if (span.textContent.trim() !== "Pre-order") {
          span.textContent = "Pre-order"
        }
      })
    }
  }

  // debounced permanent watcher
  let timer
  new MutationObserver(() => {
    clearTimeout(timer)
    timer = setTimeout(applyPreorder, 50)
  }).observe(document.body, { childList: true, characterData: true, subtree: true })

  applyPreorder()
})
